import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { KpiCard } from '@/features/dashboard-finance/KpiCard';
import { formatInt } from '@/features/dashboard-finance/formatters';

/** KPI do total de tenants (todos os status). */
export function TenantsCountCard({ total }: { total: number }): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <KpiCard
      label={t('usageBasic.cards.tenants')}
      value={formatInt(total)}
      helperText={t('usageBasic.cards.tenantsHint')}
    />
  );
}
